module.exports = {"320281001":"澄江街道","320281004":"南闸街道","320281005":"云亭街道","320281007":"申港街道","320281008":"利港街道","320281009":"夏港街道","320281100":"璜土镇","320281102":"月城镇","320281103":"青阳镇","320281104":"徐霞客镇","320281107":"华士镇","320281108":"周庄镇","320281109":"新桥镇","320281110":"长泾镇","320281111":"顾山镇","320281112":"祝塘镇","320281400":"江阴高新技术产业开发区","320281403":"江苏江阴靖江工业园区","320281404":"临港经济开发区","320281405":"青阳园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320281.json
// module id = 846
// module chunks = 0